import { render } from "./CruGKE.vue?vue&type=template&id=2d6d904c&scoped=true&ts=true"
import script from "./CruGKE.vue?vue&type=script&lang=ts"
export * from "./CruGKE.vue?vue&type=script&lang=ts"

import "./CruGKE.vue?vue&type=style&index=0&id=2d6d904c&lang=scss&scoped=true"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6d904c"]])

export default __exports__